import { useEffect, useState } from "react";
import axios from "axios";
import { API } from "@/App";
import GoogleMapView from "@/components/GoogleMapView";
import { isMapsEnabled } from "@/lib/maps";

/**
 * Renders a Google Map for an address (or lat/lng if provided directly).
 * Geocodes the address via `/api/maps/geocode` on mount.
 *
 * Props:
 *   address: free-form string OR
 *   lat, lng: numbers (skip geocoding)
 *   title: marker label
 *   zoom, height (forwarded to GoogleMapView)
 */
export default function AddressMap({ address, lat, lng, title, zoom = 14, height = "h-64" }) {
  const [coords, setCoords] = useState(lat && lng ? { lat, lng } : null);
  const [loading, setLoading] = useState(!coords);

  useEffect(() => {
    if (coords || !address || !isMapsEnabled()) { setLoading(false); return; }
    let alive = true;
    axios.get(`${API}/maps/geocode`, { params: { address } })
      .then((r) => { if (alive) setCoords({ lat: r.data.lat, lng: r.data.lng }); })
      .catch(() => {})
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [address]); // eslint-disable-line

  if (loading) return <div className={`${height} w-full bg-slate-900 rounded-xl animate-pulse`} />;
  if (!coords) {
    return (
      <div className={`${height} w-full bg-slate-900 rounded-xl flex items-center justify-center text-slate-500 text-sm`}>
        Location unavailable
      </div>
    );
  }
  return <GoogleMapView center={coords} zoom={zoom} markers={[{ ...coords, title }]} height={height} />;
}
